"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var on_1 = __importDefault(require("./api/on"));
var get_1 = __importDefault(require("./api/get"));
var has_1 = __importDefault(require("./api/has"));
var patch_1 = __importDefault(require("./api/patch"));
var node_1 = __importDefault(require("./api/node"));
var errors_1 = __importDefault(require("./errors"));
function jsonmvcdb(data) {
    // An error message should contain:
    // 1. Error number
    // 2. Location
    // 3. Description (text)
    // 4. Resource type (that triggered the error)
    // 5. Resource value (if applicable)
    // 6. Resource id (if applicable)
    var db = {
        static: {
            err: {
                types: errors_1.default,
                db: [],
                patch: [],
                node: [],
                on: [],
            },
        },
        errors: {},
        cache: {
            paths: {},
            dynamic: {},
        },
        triggers: {},
        dynamic: {
            decomposed: {},
            patching: {},
            nesting: {},
            reverseDeps: {},
            inverseDeps: {},
            staticDeps: {},
            fullDeps: {},
            deps: {},
            fns: {},
        },
        updates: {
            cache: {},
            triggers: {},
            fns: {},
        },
    };
    if (data) {
        db.static = (0, cloneDeep_1.default)(data);
        db.static.err = {
            types: errors_1.default,
            db: [],
            patch: [],
            node: [],
            on: [],
        };
    }
    return {
        on: (0, on_1.default)(db),
        get: (0, get_1.default)(db),
        has: (0, has_1.default)(db),
        patch: (0, patch_1.default)(db),
        node: (0, node_1.default)(db),
        db: db,
    };
}
exports.default = jsonmvcdb;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZGIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFDQSwrREFBd0M7QUFDeEMsZ0RBQTBCO0FBQzFCLGtEQUE0QjtBQUM1QixrREFBNEI7QUFDNUIsc0RBQWdDO0FBQ2hDLG9EQUE4QjtBQUU5QixvREFBZ0M7QUFFaEMsU0FBUyxTQUFTLENBQUMsSUFBUztJQUMxQixtQ0FBbUM7SUFDbkMsa0JBQWtCO0lBQ2xCLGNBQWM7SUFDZCx3QkFBd0I7SUFDeEIsOENBQThDO0lBQzlDLG9DQUFvQztJQUNwQyxpQ0FBaUM7SUFDakMsSUFBSSxFQUFFLEdBQWM7UUFDbEIsTUFBTSxFQUFFO1lBQ04sR0FBRyxFQUFFO2dCQUNILEtBQUssRUFBRSxnQkFBUTtnQkFDZixFQUFFLEVBQUUsRUFBRTtnQkFDTixLQUFLLEVBQUUsRUFBRTtnQkFDVCxJQUFJLEVBQUUsRUFBRTtnQkFDUixFQUFFLEVBQUUsRUFBRTthQUNQO1NBQ0Y7UUFDRCxNQUFNLEVBQUUsRUFBRTtRQUNWLEtBQUssRUFBRTtZQUNMLEtBQUssRUFBRSxFQUFFO1lBQ1QsT0FBTyxFQUFFLEVBQUU7U0FDWjtRQUNELFFBQVEsRUFBRSxFQUFFO1FBQ1osT0FBTyxFQUFFO1lBQ1AsVUFBVSxFQUFFLEVBQUU7WUFDZCxRQUFRLEVBQUUsRUFBRTtZQUNaLE9BQU8sRUFBRSxFQUFFO1lBQ1gsV0FBVyxFQUFFLEVBQUU7WUFDZixXQUFXLEVBQUUsRUFBRTtZQUNmLFVBQVUsRUFBRSxFQUFFO1lBQ2QsUUFBUSxFQUFFLEVBQUU7WUFDWixJQUFJLEVBQUUsRUFBRTtZQUNSLEdBQUcsRUFBRSxFQUFFO1NBQ1I7UUFDRCxPQUFPLEVBQUU7WUFDUCxLQUFLLEVBQUUsRUFBRTtZQUNULFFBQVEsRUFBRSxFQUFFO1lBQ1osR0FBRyxFQUFFLEVBQUU7U0FDUjtLQUNGLENBQUM7SUFFRixJQUFJLElBQUksRUFBRTtRQUNSLEVBQUUsQ0FBQyxNQUFNLEdBQUcsSUFBQSxtQkFBUyxFQUFDLElBQUksQ0FBQyxDQUFDO1FBQzVCLEVBQUUsQ0FBQyxNQUFNLENBQUMsR0FBRyxHQUFHO1lBQ2QsS0FBSyxFQUFFLGdCQUFRO1lBQ2YsRUFBRSxFQUFFLEVBQUU7WUFDTixLQUFLLEVBQUUsRUFBRTtZQUNULElBQUksRUFBRSxFQUFFO1lBQ1IsRUFBRSxFQUFFLEVBQUU7U0FDUCxDQUFDO0tBRUg7SUFFRCxPQUFPO1FBQ0wsRUFBRSxFQUFFLElBQUEsWUFBRSxFQUFDLEVBQUUsQ0FBNEI7UUFDckMsR0FBRyxFQUFFLElBQUEsYUFBRyxFQUFDLEVBQUUsQ0FBQztRQUNaLEdBQUcsRUFBRSxJQUFBLGFBQUcsRUFBQyxFQUFFLENBQUM7UUFDWixLQUFLLEVBQUUsSUFBQSxlQUFLLEVBQUMsRUFBRSxDQUErQjtRQUM5QyxJQUFJLEVBQUUsSUFBQSxjQUFJLEVBQUMsRUFBRSxDQUFDO1FBQ2QsRUFBRSxFQUFFLEVBQUU7S0FDUCxDQUFDO0FBQ0osQ0FBQztBQUVELGtCQUFlLFNBQVMsQ0FBQyJ9